export default __webpack_public_path__ + "static/media/ledger.054d95cd.png";